<template>
    <v-btn
        class="px-0 app-btn"
        :color="color"
        elevation="2"
        :disabled="disabled"
        :loading="loading"
        v-bind="$attrs"
        v-on="$listeners">
        <v-icon v-if="icon" class="app-btn-icon">
            {{ icon }}
        </v-icon>
        <span class="px-5 flex-grow-1"><slot /></span>
    </v-btn>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: "primary"
        },
        icon: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    }
};
</script>

<style lang="scss" scoped>
@import "@/styles/theme.scss";

.app-btn-icon {
    height: 1.75rem;
    width: 1.75rem;
    border-radius: 50%;
    font-size: 1.125rem;
    margin-left: 0.625rem;
    margin-right: -1.25rem;
}

.app-btn.v-size--default {
    color: #ffffff;
    font-size: 0.875rem;
    border-radius: 0.125rem;
    border-width: 0.125rem;
}

</style>
